import { Countries } from "../components/public/Home/CountryFlag";

// All Global Function to use inside the APP
export function countryCodeToName(countryCode) {
    const country = Countries.find(c => c.code === countryCode);
    return country ? country.name : null;
}

export function capitalize(str) {
    if (!str || typeof str !== 'string') return '';
    return str.split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

export const toSentenceCase = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
}

export const formatDateWithOrdinal = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const getOrdinal = (n) => {
        const s = ["th", "st", "nd", "rd"],
            v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    const monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return `${getOrdinal(day)} ${monthNamesShort[month]} ${year}`;
}

export const toSentenceCaseCP = (str) => {
    if (!str) return '';
    const stringWithSpaces = str?.replace(/_/g, ' ');
    return stringWithSpaces.charAt(0).toUpperCase() + stringWithSpaces.slice(1).toLowerCase();
}